import React, { useState, useEffect, useRef } from 'react';
import HeadingArea from '../general/HeadingArea';
import { FaCopy, FaPlus, FaPrint } from 'react-icons/fa6';
import { RiDeleteBin6Line } from 'react-icons/ri';
import ResponseMsg2 from '../general/ResponseMsg2';

const FeeStructure = ({ setLoading }) => {
  const [showAddSection, setShowAddSection] = useState(false);
  const [particular, setParticular] = useState([]);
  const [feeStr, setFeeStr] = useState([]);
  const [classes, setClasses] = useState([]);
      const [response2, setResponse2] = useState({ message: '', status: 'success' });
const [showDelete, setShowDelete]  = useState(false);
const [selectedStr, setSelectedStr] = useState(''); 
          const [ay, setAy] = useState([]);
const [selectedAY, setSelectedAY] = useState('');
  const [formData, setFormData] = useState({
    class: '',
    due_days: '',
    due_fine: '',
    feeType: '',
    annual_year: '',
  });

  // feeList: [{ id, name, amount }]
  const [feeList, setFeeList] = useState([]);
  const [selectedParticularId, setSelectedParticularId] = useState('');
  const printRef = useRef(null);

  const feeTypes = [
    { label: 'Admission fee', value: 'Admission Fee' },
    { label: 'Annual Fee', value: 'Annual Fee' },
    { label: 'Tution Fee', value: 'Tution Fee' },
    { label: 'Other Fee', value: 'Other Fee' },
    // { label: 'Quarter 2', value: 'Quarter 2' },
    // { label: 'Quarter 3', value: 'Quarter 3' },
    // { label: 'Quarter 4', value: 'Quarter 4' },
  ];

  const handleToggle = () => {
    setShowAddSection((prev) => !prev);
    if (showAddSection) {
      setFormData({
        class: '',
        due_days: '',
        due_fine: '',
        feeType: '',
        annual_year: '',
      });
      setFeeList([]);
      setSelectedParticularId('');
    }
  };

  const fetchParticular = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-fee-particular');
      if (response.ok) {
        const data = await response.json();
        setParticular(data);
      } else {
        console.error('Failed to fetch particulars');
      }
    } catch (error) {
      console.error('Error fetching particulars:', error);
    }
    setLoading(false);
  };

  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch classes');
      }
    } catch (error) {
      console.error('Error fetching classes:', error);
    }
    setLoading(false);
  };

    const fetchFeeStr = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-fee-structure');
      if (response.ok) {
        const data = await response.json();
        setFeeStr(data);
      } else {
        console.error('Failed to fetch particulars');
      }
    } catch (error) {
      console.error('Error fetching particulars:', error);
    }
    setLoading(false);
  };

       const fetchAcademicYears = async () => {
  setLoading(true);
  try {
    const response = await fetch('https://api.kcian.in/get-academic-years');

    if (response.ok) {
      const data = await response.json();
      setAy(data);
         if (data.length > 0) {
        setSelectedAY(data[0].year);
      }
    } else {
      console.error('Failed to fetch academic years');
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchParticular();
    fetchClasses();
    fetchAcademicYears();
    fetchFeeStr();
  }, []);

const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === 'class') {
    const selectedClass = classes.find((cls) => cls.id.toString() === value);
    setFormData((fd) => ({
      ...fd,
      class: selectedClass ? { classId: selectedClass.id, className: selectedClass.class_name } : '',
    }));
  } else {
    setFormData((fd) => ({
      ...fd,
      [name]: value,
    }));
  }
};

const handleAddParticular = () => {
  if (!selectedParticularId) return;
  if (feeList.find((item) => item.id === selectedParticularId)) return;

const selectedIdNum = Number(selectedParticularId);
const selected = particular.find((p) => p.id === selectedIdNum);
  if (selected) {
setFeeList((prev) => [
  ...prev, 
  { 
    feePartId: selected.id,
    feePartName: selected.fee_type,
    feePartType: selected.fee_category,  // assuming fee_category or any other field
    amount: 0
  }
]);
    setSelectedParticularId('');
  }
};

const handleRemoveParticular = (feePartId) => {
  setFeeList((prev) => prev.filter((item) => item.feePartId !== feePartId));
};

const handleAmountChange = (feePartId, amount) => {
  if (isNaN(amount)) return;
  setFeeList((prev) =>
    prev.map((item) =>
      item.feePartId === feePartId ? { ...item, amount: Number(amount) } : item
    )
  );
};

  const handleFeeTypeChange = (value) => {
    setFormData((fd) => ({
      ...fd,
      feeType: fd.feeType === value ? '' : value,
    }));
  };

  const totalAmount = feeList.reduce((acc, curr) => acc + (curr.amount || 0), 0);

  const handleSubmit = async (e) => {
    e.preventDefault();

      if (feeList.length === 0) {
    setResponse2({ message: 'Please Add at least One Fee Particular.', status: 'error' });
    setTimeout(() => setResponse2(''), 3000);
    return;
  }

const fee_list = feeList.map(({ feePartId, feePartName, feePartType, amount }) => ({
  feePartId,
  feePartName,
  feePartType,
  amount,
}));


    if(formData.feeType == ''){
                              setResponse2({ message: 'Select Structure Type', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
return;
    }

    const hasInvalidAmount = feeList.some(({ amount }) => !amount || Number(amount) <= 0);
  if (hasInvalidAmount) {
    setResponse2({ message: 'Amount cannot be Zero or Empty for any Fee Particular.', status: 'error' });
    setTimeout(() => setResponse2(''), 3000);
    return;
  }

    const payload = {
      classId: formData.class || '',
      due_days: formData.due_days,
      due_fine: formData.due_fine,
      feeType: formData.feeType,
      annual_year: formData.annual_year,
      total_amount: totalAmount,
      fee_list,
    };

    console.log('Submitting payload:', payload);

    try {
      setLoading(true);
      const res = await fetch('https://api.kcian.in/add-fee-structure', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      setLoading(false);

      if (res.ok) {
                        setResponse2({ message: 'Fee Structure Added Successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);
        handleToggle();
        fetchFeeStr();
      } else {
        // alert('Failed to save fee structure.');
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);   
      }
    } catch (error) {
      setLoading(false);
      console.error('Error saving fee structure:', error);
      // alert('Error occurred while saving.');
    }
  };

    const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


      const handleShowDelete = (feeS) => {
    setSelectedStr(feeS);
    setShowDelete(true);
  }


                const handleDelete = async (strId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-fee-structure/${strId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setFeeStr((prevData) => prevData.filter((product) => product.id !== strId));
        setShowDelete(false);
        setResponse2({ message: 'Fee Structure Deleted Successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting fee particular:', error);
    }
  };



  const handleCopyStructure = (feeS) => {
  try {
    const classData = JSON.parse(feeS.class_id);
    const feeListArr = JSON.parse(feeS.fee_list);

    // 1️⃣ Open form
    setShowAddSection(true);

    // 2️⃣ Fill form fields
    setFormData({
      class: {
        classId: classData.classId,
        className: classData.className
      },
      due_days: feeS.due_days,
      due_fine: feeS.due_fine,
      feeType: feeS.structure_type,
      annual_year: feeS.annual_year,
    });

    // 3️⃣ Fill fee_list
    const mappedFeeList = feeListArr.map((f) => ({
      feePartId: f.feePartId,
      feePartName: f.feePartName,
      feePartType: f.feePartType,
      amount: f.amount,
    }));

    setFeeList(mappedFeeList);

  } catch (error) {
    console.error("Copy Error:", error);
  }
};

const filteredFeeStr = selectedAY
  ? feeStr.filter((item) => item.annual_year === selectedAY)
  : feeStr;


      const handlePrint = () => {
    if (!filteredFeeStr.length) {
      setResponse2({ message: 'No Data in Fee Structure to Print.', status: 'success' });
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
      return;
    }
    window.print();
  };

  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='General Settings' message2='Fees Structure' />

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

          {!showAddSection ? (
            <div className='profile-card'>

              <div className='d-flex justify-content-between'>
              <button className='profile-btn2' onClick={handleToggle}>
                <FaPlus /> Add
              </button>

                              <div className='profile-input-area col-md-3 col-7 ms-2'>
                  <label className="profile-badge">Select AY*</label>
                  <select
                    className="profile-input"
                    value={selectedAY}
                    onChange={(e) => setSelectedAY(e.target.value)}
                    required
                  >
                    <option value="">-- Select Academic Year --</option>
                    {ay.map((ay) => (
                      <option key={ay.year} value={ay.year}>
                        {ay.year}
                         {/* --- {ay.title} */}
                      </option>
                    ))}
                  </select>
                </div>
                
                </div>

            <div className='text-end mt-2'>

             <button
              className="profile-btn2"
              onClick={handlePrint}
              // disabled={!filteredFeeStr.length}
            >
              <FaPrint /> Print
            </button>
            </div>

              <div ref={printRef} className=' printable-area table-responsive mt-4'>

<div className='text-center mb-3'>
  <p className='fs-3 fw-bold mb-0'>KC PUBLIC SCHOOL</p>
  <p className='fs-5 fw-semibold'>Fee Structure for Academic Year {selectedAY}</p></div>

                <table className='w-100 text-center'>
                  <thead className='account-thead'>
                    <tr>
                      <th className='border d-print-none'>S No</th>
                      <th className='border'>Class</th>
                      <th className='border' colSpan={3}>Fee List</th>
                      <th className='border d-print-none'>Added On</th>
                      <th className='border'>Collect Dues After</th>
                      <th className='border'>Due Fine</th>
                      {/* <th className='border'>Annual Year</th> */}
                      <th className='border d-print-none'>Structure Type</th>
                      <th className='border d-print-none'>Activity</th>
</tr>

<tr className='border-top'>
    <th className='border d-print-none'></th>
    <th className='border'></th>
    <th className='border'>Fee Type</th>
    <th className='border'>Fee Name</th>
    <th className='border'>Amount (₹)</th>
    <th className='border d-print-none'></th>
    <th className='border'>(Days)</th>
    <th className='border'>(₹)</th>
    {/* <th className='border'>(A Y)</th> */}
    <th className='border d-print-none'></th>
    <th className='border d-print-none'></th>
    </tr>
</thead>

                  <tbody>
                     {filteredFeeStr.length > 0 ? (
                    filteredFeeStr.map((feeS, index) => {
                      const feeListArr = JSON.parse(feeS.fee_list);
                      return (
<tr className='account-tr'>
<td className='border d-print-none'>{index + 1}</td>
<td className='border'>{JSON.parse(feeS.class_id).className}</td>
<td className='border p-0'>
    {feeListArr.map((fee, index) => (
      <div   className={`p-2 ${index < feeListArr.length - 1 ? 'border-bottom' : ''}`}>
      <span>{fee.feePartType}</span>
      {/* <td className='border col-6'>{fee.feePartName}</td>
      <td className='border col-6'>{fee.amount}</td> */}
      </div>
   ))}
</td>
<td className='border p-0'>
    {feeListArr.map((fee, index) => (
      <div   className={`p-2 ${index < feeListArr.length - 1 ? 'border-bottom' : ''}`}>
      {/* <td className='border col-6'>{fee.feePartType}</td> */}
      <span>{fee.feePartName}</span>
      {/* <td className='border col-6'>{fee.amount}</td> */}
      </div>
   ))}
</td>
<td className='border p-0'>
    {feeListArr.map((fee, index) => (
      <div   className={`p-2 ${index < feeListArr.length - 1 ? 'border-bottom' : ''}`}>
      {/* <td className='border col-6'>{fee.feePartType}</td>
      <td className='border col-6'>{fee.feePartName}</td> */}
      <span>{fee.amount}</span>
      </div>
   ))}
</td>
<td className='border d-print-none'>{formatDateTime(feeS.added_on)}</td>
<td className='border'>{feeS.due_days}</td>
<td className='border'>{feeS.due_fine}</td>
{/* <td className='border'>{feeS.annual_year}</td> */}
<td className='border d-print-none'>{feeS.structure_type}</td>
<td className='border d-print-none'><FaCopy className='account-icon2 me-2' title='Copy' onClick={() => handleCopyStructure(feeS)} />
  <RiDeleteBin6Line className='account-icon1' title='Delete' onClick={() => handleShowDelete(feeS)} />
</td>
</tr>
                    )
                    })): 
                    (
                      <tr className='account-tr'>
      <td className='py-3' colSpan={11}>
        No Fee Structure Found For Selected Academic Year.
      </td>
    </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            // Add Fee Structure Form
            <div className='mt-4'>
              <p className='profile-heading'>Add Fees Structure</p>

              <form className='row' onSubmit={handleSubmit}>
                <div className='col-lg-4 col-12 my-2'>
                  <div className='profile-card'>
                    {/* Select Class */}
                    <div className='mb-4'>
                      <div className='profile-input-area'>
                        <label className='profile-badge'>Select Class*</label>
                        <select
                          name='class'
                          className='profile-input'
                          required
                          value={formData.class?.classId || ''}
                          onChange={handleChange}
                        >
                          <option value=''>-- Select Class --</option>
                          {classes.map((cls) => (
                            <option key={cls.id} value={cls.id}>
                              {cls.class_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Annual Year */}
                                        <div className='mb-4'>
                      <div className='profile-input-area'>
                        <label className='profile-badge'>Select AY*</label>
                        <select
                          name='annual_year'
                          className='profile-input'
                          required
                          value={formData.annual_year}
                          onChange={handleChange}
                        >
                          <option value=''>-- Select AY --</option>
                      {ay.map((ayear) => (
                        <option key={ayear.year} value={ayear.year}>
                          {ayear.year} --- {ayear.title}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Collect Dues After */}
                    <div className='mb-4'>
                      <div className='profile-input-area'>
                        <label className='profile-badge'>Collect Dues After (Days)*</label>
                        <input
                          type='number'
                          name='due_days'
                          className='profile-input'
                          placeholder='10'
                          required
                          value={formData.due_days}
                          onChange={handleChange}
                          min={0}
                        />
                      </div>
                    </div>

                    {/* Due Fine Amount */}
                    <div className='mb-4'>
                      <div className='profile-input-area'>
                        <label className='profile-badge'>Due Fine Amount</label>
                        <input
                          type='number'
                          name='due_fine'
                          className='profile-input'
                          placeholder='0'
                          value={formData.due_fine}
                          onChange={handleChange}
                          min={0}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-lg-8 col-12 my-2'>
                  <div className='profile-card'>
                    <p>Fee Particulars List</p>
                    {/* <hr /> */}

                    {/* Fee Particular Dropdown + Add Button */}
                    <div className='d-flex'>
                      <div className='profile-input-area me-2 w-100'>
                                                {/* <label className='profile-badge'>Select Particular</label> */}
                      <select
                        className='profile-input py-2'
                        value={selectedParticularId}
                        onChange={(e) => setSelectedParticularId(e.target.value)}
                      >
                        <option value=''>Fee Type &nbsp;---&nbsp; Fee Category</option>
                        {particular.map((p) => (
                          <option key={p.id} value={p.id}>
                            {p.fee_type} &nbsp;---&nbsp; {p.fee_category}
                          </option>
                        ))}``
                      </select>
                      </div>
                      <button
                        type='button'
                        className='profile-btn2'
                        onClick={handleAddParticular}
                        disabled={!selectedParticularId}
                      >
                        Add
                      </button>
                    </div>

                    {/* Fee Particulars List */}
                    <div className='table-responsive my-4'>
                      <table className='w-100'>
                        <thead className='account-thead d-flex rounded-4'>
                          <th style={{flex: 1}}>S No</th>
                          <th style={{flex: 1}}>Fee Type</th>
                          <th style={{flex: 0.5}}>Amount</th>
                          <th className='text-end' style={{flex: 1}}>Activity</th>
                        </thead>
                                            {feeList.length === 0 && <tr className='account-tr text-center'><td colSpan={4}>No particulars added yet.</td></tr>}
                    {feeList.map(({ feePartId, feePartName, feePartType, amount }) => (
                      <tr
                        key={feePartId}
                        className='account-tr d-flex'
                      >
                        <td style={{flex: 1}}>{feePartId}</td>
                        <td style={{flex: 1}}>{feePartName}</td>
                        <td style={{flex: 0.5}}><div className='profile-input-area'>
                          <input
                          type='number'
                          value={amount}
                          onChange={(e) => handleAmountChange(feePartId, e.target.value)}
                          className='profile-input py-0'
                          placeholder='Amount'
                        /></div>
                        </td>
                        <td style={{flex: 1}} className='text-end'>
                          <RiDeleteBin6Line className='account-icon1' title='Remove' onClick={() => handleRemoveParticular(feePartId)} /></td>
                      </tr>
                    ))}
</table>
</div>


                    {/* Fee Type Checkbox Group */}
                    <p>Select Structure Type*</p>
                    <div className='d-flex flex-wrap' style={{ gap: '15px' }}>
                      {feeTypes.map(({ label, value }) => (
                        <label key={value} style={{ userSelect: 'none' }}>
                          <input
                            type='checkbox'
                            name='feeType'
                            value={value}
                            checked={formData.feeType === value}
                            onChange={() => handleFeeTypeChange(value)}
                          />{' '}
                          {label}
                        </label>
                      ))}
                    </div>

                    <hr />

                    {/* Total Amount */}
                    <p>
                      <strong>Total Amount:</strong> ₹{totalAmount.toFixed(2)}
                    </p>
                  </div>
                </div>

                <div className='mt-3'>
                  <button onClick={handleToggle} type='button' className='profile-btn2'>
                    Cancel
                  </button>
                  <button type='submit' className='ms-2 profile-btn'>
                    Save Structure
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>
      </section>

                {showDelete && (() =>   {
                      const feeListArr = JSON.parse(selectedStr.fee_list);
                       const rowSpanCount = feeListArr.length || 1;
               return (
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Fee Structure!</p>

<div className='table-responsive'>
<table className='w-100'>

                  <thead className='account-thead'>
                    <tr>
                      <th className='border'>Class</th>
                      <th className='border' colSpan={3}>Fee List</th>
                      <th className='border'>Added On</th>
                      <th className='border'>Collect Dues After</th>
                      <th className='border'>Due Fine</th>
                      <th className='border'>Annual Year</th>
                      <th className='border'>Structure Type</th>
</tr>

<tr className='border-top'>
    <th></th>
    <th className='border'>Fee Name</th>
    <th className='border'>Fee Type</th>
    <th className='border'>Amount (₹)</th>
    <th></th>
    <th className='border'>(Days)</th>
    <th className='border'>(₹)</th>
    <th className='border'>(A Y)</th>
    <th></th>
    </tr>
</thead>

<tr className='account-tr'>
{/* <td className='border'>{index + 1}</td> */}
<td className='border'>{JSON.parse(selectedStr.class_id).className}</td>
<td colSpan={3} className='border'>
    {feeListArr.map((fee) => (
      <>
      <tr>
      <td>{fee.feePartName}</td>
      <td>{fee.feePartType}</td>
      <td>{fee.amount}</td>
      </tr>
</>    ))}
</td>
<td className='border'>{formatDateTime(selectedStr.added_on)}</td>
<td className='border'>{selectedStr.due_days}</td>
<td className='border'>{selectedStr.due_fine}</td>
<td className='border'>{selectedStr.annual_year}</td>
<td className='border'>{selectedStr.structure_type}</td>
</tr>

</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Fee Structure will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedStr.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
);
})()}

      <style>{`
@media print {
  body * {
    visibility: hidden;
    
  }
  .printable-area, .printable-area * {
    visibility: visible;
    color: black;
  }
  .printable-area {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .d-print-none {
    display: none !important;
  }
  .printable-area .row {
    display: flex !important;
    flex-wrap: wrap !important;
  }
  .printable-area .col-lg-3{ 
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
}

      `}</style>
    </>
  );
};

export default FeeStructure;
